module.exports = __webpack_public_path__ + "img/数据总量.722dde4d.svg";